import {
  Component,
  OnInit,
  ChangeDetectorRef,
  EventEmitter,
  Output
} from "@angular/core";
import { Observable } from "rxjs/Rx";
import { GeocodingService } from "../geocoding.service";
import { MapService } from "../map.service";
import { Location } from "../location";
import { MessageService } from "primeng/components/common/messageservice";
import {
  ElementRef,
  ViewChild,
  Directive,
  HostListener,
  Input
} from "@angular/core";
import { map } from "rxjs/operators";
import { MapOperator } from "rxjs/operators/map";
import { MatSnackBar } from "@angular/material";
import { OffrecommercialeService } from "../offrecommerciale/offrecommerciale.service";
import { HttpClient } from "@angular/common/http";
import "rxjs/add/operator/catch";
import "leaflet-sidebar-v2";
import "leaflet-easybutton";
import "leaflet-wfst";
import { TranslateService } from "@ngx-translate/core";
declare var L: any;
import { Icon, icon, Marker, marker } from "leaflet";
import { PortService } from "../port/port.service";
import { Geoserver } from "../geoserver/model/geoserver";
import { Port } from "../port/model/port";
import { MarkerInfos } from "./markerInfos";
import { tokengeoserver } from "../geoserver/tokengeoserver";

@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],

  providers: [MessageService]
})
export class MapComponent implements OnInit {
  ADRESSE: string;
  positionValue = "bottomright";
  mondayLayer: any;
  public map;
  private vtLayer: any;
  allgeojson: any[];
  layerlrm2: any;
  depart: any;
  arive: any;
  on: boolean;
  ports: any;
  PORT_MARKER_NOT_VISIBLE = "MARSEILLE";
  portplusproche: Port;
  toggle: boolean = false;
  address: string;
  refrechButton: any;
  showHideButton: any;
  mywms1: any;
  mywmsEn: any;
  boundary: any;
  portpluproch: Port;
  isurlGeoserver: boolean = false;
  urlGeoserver: Geoserver[];
  public coucheport;
  portsTouches: Port[];
  // tslint:disable-next-line:max-line-length
  tokenGeoservertiles: string =
    tokengeoserver.GeosrverProtocolHttps +
    tokengeoserver.GeoserverTileEN +
    tokengeoserver.GeoserverWFSEN +
    tokengeoserver.GeoserverTIFEN;
  portMarseille: Marker;

  @Output()
  rechercheEmitter: EventEmitter<MarkerInfos> = new EventEmitter<MarkerInfos>();

  @Output()
  static rechercheMarker: EventEmitter<MarkerInfos> = new EventEmitter<
    MarkerInfos
  >();
  constructor(
    private mapService: MapService,
    private geocoder: GeocodingService,
    private portsService: PortService,
    public http: HttpClient,
    private translate: TranslateService
  ) {
    this.address = "";
  }
  /* Methde principale  pour gérer l'affichage de la carte et la couche des ports  */
  private defaultIcon: Icon = icon({
    iconUrl: "assets/marker-icon.png",
    iconSize: [26, 34]
  });

  async ngOnInit() {
    var southWest = L.latLng(-90, -190),
      northEast = L.latLng(90, 190),
      bounds = L.latLngBounds(southWest, northEast);
    Marker.prototype.options.icon = this.defaultIcon;
    var a = L.latLng(43.32812, 5.35204);
    // get the width of the screen after the resize event
    var width = document.documentElement.clientWidth;
    var minZoom = 1;
    // Son est sur un grand ecran on reduit le zoom max
    if (width > 1000) {
      minZoom = 3;
    }
    this.map = L.map("map", {
      zoomControl: false,
      center: a,
      maxBounds: bounds,
      zoom: minZoom,
      minZoom: minZoom,
      maxZoom: 13,
      maxBoundsViscosity: 0.7
    });
    /* Couche WMS et WFS */
    let geoserverURL;
    this.portsService.getGeoserverUrl().subscribe(data => {
      const geoserverUrl = data;
      this.mywms1 = L.tileLayer.wms(data.url + "/cite/wms?", {
        layers: "cite:OSM-WMS",
        format: "image/png",
        transparent: true,
        version: "1.1.0",
        attribution: "OSM-FR",
        noWrap: false
      });
      if (this.translate.currentLang == "fr") {
        this.mywms1.addTo(this.map);
      }
    });

    this.portsService.getGeoserverUrl().subscribe(data => {
      const geoserverUrl = data;
      this.mywmsEn = L.tileLayer.wms(data.url + "/cite/wms?", {
        layers: "cite:OSMEN",
        format: "image/png",
        transparent: true,
        version: "1.1.0",
        attribution: "OSM-EN",
        noWrap: false
      });
      if (this.translate.currentLang == "en") {
        this.mywmsEn.addTo(this.map);
      }
    });
    MapComponent.rechercheMarker = this.rechercheEmitter;
    const location = new Location();
    var treeIconList = L.icon({
      iconUrl: "assets/marker-icon.png"
    });
    var treeIconHvoya = L.icon({
      iconUrl: "assets/marker-icon.png"
    });

    this.portsService.getGeoserverUrl().subscribe(
      data => {
        L.tileLayer.wms(data.url, {
          layers: "cite:WPI",
          format: "image/png",
          transparent: true,
          version: "1.1.0",
          attribution: "OSM"
        });

        this.portplusproche = new L.WFS({
          url: data.url + "/cite/ows?",
          typeNS: "cite",
          typeName: "WPI",
          crs: L.CRS.EPSG4326,
          geometryField: "the_geom",
          style: {
            color: "blue",
            weight: 2
          }
        });
      },
      error => {
        alert("La connexion à GeoServer a échoué  !!");
      }
    );
    var greenIcon = L.icon({
      iconUrl: "assets/marker-icon.png",
      iconSize: [26, 34] // size of the icon
    });

    var redIcon = L.icon({
      iconUrl: "assets/red.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });

    /*
        @Les controleurs

    */
    L.control.zoom({ position: "bottomright" }).addTo(this.map);
    this.mapService.disableMouseEvent();
    // Positionnement de l'icone layer
    var overlays = {
      Port: this.mapService.baseMaps.OpenStreetMapEN
    };
    L.control.layers(null, overlays, { position: "bottomright" });
    // Positionnement de l'icone layer
    const portServices = this.portsService;
    this.showHideButton = L.easyButton({
      position: this.positionValue,
      states: [
        {
          stateName: "zoom-to-f", // name the state
          icon: '<img src="assets/icon2.png">', // and define its properties
          onClick: function(btn, map) {
            map.eachLayer(function(layer) {
              if (!(layer instanceof L.TileLayer)) {
                if (
                  !(layer._latlng.lat == 43.3461 && layer._latlng.lng == 5.3342)
                ) {
                  if (layer.options.opacity != 3) {
                    map.removeLayer(layer);
                  }
                }
              }
            });
            btn.state("zoom-to-s"); // change state on click!
          }
        },
        {
          stateName: "zoom-to-s",
          icon: '<img src="assets/icon2.png">',
          onClick: function(btn, map) {
            //   window.location.reload();
            /* Afficher / Masquer les ports touchés */
            portServices.getAllPortsTouches().subscribe(data => {
              this.portsTouches = data;
              for (let i = 0; i < this.portsTouches.length; i++) {
                const location = new Location();
                location.latlng = L.latLng(1, 1);
                if (!this.portsTouches[i].lat) {
                  location.latlng = L.latLng(1, 1);
                } else {
                  location.latlng = L.latLng(
                    this.portsTouches[i].lat,
                    this.portsTouches[i].lon
                  );
                }
                let markerInfo: MarkerInfos = new MarkerInfos(
                  this.portsTouches[i].id,
                  location.latlng,
                  this.portsTouches[i].nom,
                  this.portsTouches[i].flag,
                  this.portsTouches[i].pays,
                  false
                );
                let icon = L.icon({
                  iconUrl: "assets/marker-icon.png",
                  iconSize: [26, 34]
                });
                const shortLat =
                  Math.round(markerInfo.coord.lat * 1000000) / 1000000;
                const shortLng =
                  Math.round(markerInfo.coord.lng * 1000000) / 1000000;
                const popup = `<ul style="list-style-position: inside;list-style-image:url(assets/boat-red.png);color:red"><li><b id="marker" data-id="${markerInfo.id}"> ${markerInfo.nom}</b></li></ul><ul style=" list-style-position: inside;list-style-image :url(assets/images/flags/${markerInfo.flag}.png);"><li> ${markerInfo.pays}</li></ul>`;

                let marker1 = L.marker(markerInfo.coord, {
                  draggable: false,
                  icon
                })
                  .bindPopup(popup, {
                    offset: L.point(12, 6)
                  })
                  .openPopup();

                if (this.portsTouches[i].nom != "MARSEILLE") {
                  marker1.addTo(map);
                }
                icon = L.icon({
                  iconUrl: "assets/marker-icon.png",
                  iconSize: [26, 34]
                });
                /*Ajout du markerk au clic */
                marker1.on("popupopen", function(e) {
                  let clickedMarker = new DOMParser()
                    .parseFromString(
                      e.target._popup._contentNode.innerHTML,
                      "text/html"
                    )
                    .getElementById("marker");
                  marker1.options.opacity = 4;
                  let id = clickedMarker.getAttribute("data-id");
                  let nom = clickedMarker.textContent;
                  let markerInfos: MarkerInfos = new MarkerInfos(
                    id,
                    null,
                    nom,
                    null,
                    null,
                    false
                  );
                  MapComponent.rechercheMarker.emit(markerInfos);
                  marker1.setIcon(redIcon);
                });
              }
            });
            btn.state("zoom-to-f");
          }
        }
      ]
    });
    this.showHideButton.addTo(this.map);
    this.refrechButton = L.easyButton(
      '<img src="assets/icon1.png">',
      function(btn, map) {
        window.location.reload();
      },
      { position: this.positionValue }
    );
    this.map.addControl(this.refrechButton);
    this.address = location.ADRESSE;
    this.mapService.map = this.map;
    this.geocoder.map = this.map;

    /*  affichage du message dessous de la page  */
    var myStyle = {
      color: "#ff7800",
      weight: 5,
      opacity: 0.65
    };

    function changeMap() {
      this.map.invalidateSize();
    }
    var blueIcon = L.icon({
      iconUrl: "assets/current.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });
    this.portMarseille = L.marker([43.3461, 5.3342], { icon: blueIcon });
    this.portMarseille
      .bindPopup(
        '<ul style="list-style-position: inside;list-style-image:url(assets/boat-red.png);color:red"><li><b>Marseille fos sur mer</b></li></ul><ul style=" list-style-position: inside;list-style-image :url(assets/images/flags/fr.png);"><li>FRANCE</li></ul>'
      )
      .addTo(this.map);
    this.portMarseille.options.opacity = 2;
    //Affichage du marker en couleu vert
    this.portMarseille.on("popupopen", function(e) {
      this.portMarseille.setIcon(redIcon);
    });

    //Afichage du marker en couleur blue
    this.portMarseille.on("popupclose", function(e) {
      this.portMarseille.setIcon(blueIcon);
    });
  }

  /* Recherche geocoding  */
  addr() {
    if (!this.toggle) {
      this.boundary.addTo(this.map);

      this.toggle = true;
    } else {
      this.map.removeLayer(this.boundary);

      this.toggle = false;
    }
  }

  /** Partie qui gére les markers sur la map pour les ports référentiel/ port non référentiés */
  public addMarkersearch(markerInfos: MarkerInfos) {
    /*refresher  la carte avant d'afficher le résultat sur la carte */
    const mapLayer = this.map;
    var greenIcon = L.icon({
      iconUrl: "assets/marker-icon.png",
      iconSize: [26, 34]
    });
    this.map.eachLayer(function(layer) {
      if (!(layer instanceof L.TileLayer)) {
        // On remet à jour le marker dernierement selectionné en vert
        if (layer.options.opacity == 4) {
          layer.setIcon(greenIcon);
          layer.closeTooltip();
        } else if (layer.options.opacity == 3) {
          // On supprime les markers de reverse geocoding
          mapLayer.removeLayer(layer);
        }
      }
    });

    const popup = `<ul style="list-style-position: inside;list-style-image:url(assets/boat-red.png);color:red"><li><b id="marker" data-id="${markerInfos.id}"> ${markerInfos.nom}</b></li></ul><ul style=" list-style-position: inside;list-style-image :url(assets/images/flags/${markerInfos.flag}.png);"><li> ${markerInfos.pays}</li></ul>`;

    let icon: any;
    if (!markerInfos.islocalite) {
      icon = L.icon({
        iconUrl: "assets/red.png",
        iconSize: [26, 34]
      });
    } else {
      icon = L.icon({
        iconUrl: "assets/marker-icon.png",
        iconSize: [26, 34]
      });
    }
    const marker = L.marker(markerInfos.coord, {
      draggable: false,
      icon
    })
      .bindPopup(popup, {
        offset: L.point(12, 6)
      })
      .openPopup();

    marker.bindTooltip(markerInfos.nom, {
      permanent: true,
      className: "myCSSClass",
      offset: [0, 0]
    });
    marker.options.opacity = 3;
    marker.addTo(this.map);
    marker.openPopup();
    const blueIcon = L.icon({
      iconUrl: "assets/current.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });

    const redIcon = L.icon({
      iconUrl: "assets/red.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });

    if (!this.portMarseille.getTooltip()) {
      this.portMarseille.bindTooltip("<b>Marseille Fos sur mer</b>", {
        permanent: true,
        className: "myCSSClass",
        offset: [0, 0]
      });
      this.portMarseille.openTooltip();
    }

    let markerLinked: MarkerInfos = markerInfos.getLinkedMarker();
    if (markerLinked != null) {
      var mapBounds = L.latLngBounds([
        [43.3461, 5.3342],
        [markerInfos.coord.lat, markerInfos.coord.lng],
        [markerLinked.coord]
      ]);
    } else {
      var mapBounds = L.latLngBounds([
        [43.3461, 5.3342],
        [markerInfos.coord.lat, markerInfos.coord.lng]
      ]);
    }

    // get the width of the screen after the resize event
    var width = document.documentElement.clientWidth;
    //Fixer le zoom en fonction de l'emprise et de la taille d'ecran
    if (width > 768) {
      this.map.fitBounds(mapBounds, { padding: [350, 80] });
    } else {
      this.map.fitBounds(mapBounds, { padding: [50, 70] });
    }
  }

  /*Ajout des markers sur la carte */
  public addMarker(markerInfos: MarkerInfos) {
    let icon: any;
    let marker: any;
    if (markerInfos.islocalite) {
      icon = L.icon({
        iconUrl: "assets/red.png",
        iconSize: [26, 34]
      });
    } else {
      icon = L.icon({
        iconUrl: "assets/marker-icon.png",
        iconSize: [26, 34]
      });
    }
    const redIcon = L.icon({
      iconUrl: "assets/red.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });
    const shortLat = Math.round(markerInfos.coord.lat * 1000000) / 1000000;
    const shortLng = Math.round(markerInfos.coord.lng * 1000000) / 1000000;
    const popup = `<ul style="list-style-position: inside;list-style-image:url(assets/boat-red.png);color:red"><li><b id="marker" data-id="${markerInfos.id}"> ${markerInfos.nom}</b></li></ul><ul style=" list-style-position: inside;list-style-image :url(assets/images/flags/${markerInfos.flag}.png);"><li> ${markerInfos.pays}</li></ul>`;

    if (markerInfos.islocalite) {
      marker = L.marker(markerInfos.coord, {
        draggable: false,
        icon
      });
      if (markerInfos.id == 1) {
        marker.options.opacity = 3;
      } else {
        marker.options.opacity = 4;
      }
      marker.addTo(this.map);
      icon = L.icon({
        iconUrl: "assets/red.png",
        iconSize: [26, 34]
      });
      marker.on("popupopen", function(e) {
        marker.setIcon(redIcon);
      });
    } else {
      marker = L.marker(markerInfos.coord, {
        draggable: false,
        icon
      })
        .bindPopup(popup, {
          offset: L.point(12, 6)
        })
        .openPopup();

      marker.addTo(this.map);
      icon = L.icon({
        iconUrl: "assets/marker-icon.png",
        iconSize: [26, 34]
      });
      /*Ajout du markerk au clic */
      marker.on("popupopen", function(e) {
        let clickedMarker = new DOMParser()
          .parseFromString(e.target._popup._contentNode.innerHTML, "text/html")
          .getElementById("marker");
        marker.options.opacity = 4;
        let id = clickedMarker.getAttribute("data-id");
        let nom = clickedMarker.textContent;
        let markerInfos: MarkerInfos = new MarkerInfos(
          id,
          null,
          nom,
          null,
          null,
          false
        );
        MapComponent.rechercheMarker.emit(markerInfos);
        marker.setIcon(redIcon);
      });
    }
  }
  /*Changer le fond de la carte selon la langue choisie */
  public changeLangue(langue: string) {
    const basmapEn = this.mywmsEn;
    const basemap = this.map;
    const basemapFr = this.mywms1;
    if (langue == "fr") {
      basemap.eachLayer(function(layer) {
        if (layer instanceof L.TileLayer) {
          basemap.removeLayer(layer);
          basemap.addLayer(basmapEn);
        }
      });
    } else {
      basemap.eachLayer(function(layer) {
        if (layer instanceof L.TileLayer) {
          basemap.removeLayer(layer);
          basemapFr.addTo(basemap);
        }
      });
    }
  }
  private removeMarker(coord: any) {
    const shortLat = Math.round(coord.lat * 1000000) / 1000000;
    const shortLng = Math.round(coord.lng * 1000000) / 1000000;
    const marker = L.marker(coord);
    this.map.removeLayer(marker);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/map/map.component.ts